<template>
    <div class="about">
        <BasicTemplate :page-id="3" v-if="data">
            <History :title="data.history.title" :list="data.history.list" />
            <Recipes :title="data.recipes.title" :list="data.recipes.list" />
            <Achivements :title="data.achivements.title" :list="data.achivements.list" />
            <Vacancies
                v-if="data.vacancies.list.length > 0"
                :title="data.vacancies.title"
                :list="data.vacancies.list"
                :img="data.vacancies.img"
            />
        </BasicTemplate>
    </div>
</template>

<script>
import BasicTemplate from "./BasicTemplate.vue";
import History from "../containers/History.vue";
import Recipes from "../containers/Recipes.vue";
import Achivements from "../containers/Achivements.vue";
import Vacancies from "../containers/Vacancies.vue";

import utils from "../utils";
import FirstoreUtils from "../firestore-utils";
export default {
    name: "About",
    data() {
        return {
            data: undefined,
            utils: utils,
            metaTitle: undefined,
            metaDescription: undefined,
            metaKeywords: undefined,
            metaImage: undefined,
            metaUrl: undefined,
        };
    },
    metaInfo() {
        return {
            title: this.metaTitle,
            meta: [
                { name: "yandex-verification", content: "b7c03678b09c3394" },
                {
                    name: "title",
                    property: "title",
                    content: this.metaTitle,
                },
                {
                    name: "description",
                    property: "description",
                    content: this.metaDescription,
                },
                {
                    name: "keywords",
                    property: "keywords",
                    content: this.metaKeywords,
                },
                {
                    name: "og:title",
                    property: "og:description",
                    content: this.metaTitle,
                },
                {
                    name: "og:description",
                    property: "og:description",
                    content: this.metaDescription,
                },
                {
                    name: "og:image",
                    property: "og:image",
                    content: this.metaImage,
                },
                {
                    name: "og:url",
                    property: "og:url",
                    content: this.metaUrl,
                },
            ],
        };
    },

    methods: {},
    mounted() {
        FirstoreUtils.fetchData("about").then(data => {
            this.data = data;
            this.metaUrl = window.location.href;
            this.metaImage = data.meta.img.src;
            this.metaTitle = data.meta.title;
            this.metaDescription = data.meta.description;
            this.metaKeywords = data.meta.keywords;
            setTimeout(() => {
                document.dispatchEvent(new Event("x-app-rendered"));
            }, 5000);
        });
    },
    components: {
        BasicTemplate,
        History,
        Recipes,
        Achivements,
        Vacancies,
    },
};
</script>

<style lang="scss">
.about {
}
</style>
